'use client';

import { Box, Button, GridLayout, Typography } from '@wishket/design-system';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { twJoin } from 'tailwind-merge';

import { RollingGraphics } from './RollingGraphics';
import { backgroundGradientSvgString } from './backgroundGradientSvg';

import { PATH } from '@/shared/constants';
import { useAuth } from '@/shared/hooks';

const signUpBannerProps = {
  guest: {
    description: '지금 회원가입하고\n실무 꿀팁을 스크랩해 보세요.',
    buttonText: '회원가입',
    buttonLink: PATH.AUTH_SIGNUP,
  },
  user: {
    description: '방금 본 컬렉션 맘에 들었다면?\n더 많은 컬렉션이 기다려요.',
    buttonText: '컬렉션 바로가기',
    buttonLink: PATH.COLLECTION,
  },
};

const SignUpBanner = () => {
  const { isAuth } = useAuth();
  const pathname = usePathname();
  const { description, buttonText, buttonLink } = isAuth
    ? signUpBannerProps.user
    : {
        ...signUpBannerProps.guest,
        buttonLink: `${signUpBannerProps.guest.buttonLink}?next=${pathname}`,
      };

  return (
    <Box
      className={twJoin('h-[254px] w-full bg-cover bg-center')}
      style={{
        backgroundImage: `url("data:image/svg+xml;utf8,${encodeURIComponent(backgroundGradientSvgString)}")`,
      }}
      data-testid="landing-sign-up-banner"
    >
      <GridLayout gridTemplateAreaClass="grid-areas-landing-sign-up-banner-mobile h-full items-center tablet:grid-areas-landing-sign-up-banner-tablet desktop:grid-areas-landing-sign-up-banner-desktop">
        <Box className="flex flex-col gap-6 grid-in-description">
          <Typography
            variant="subTitle2"
            className="whitespace-pre-line font-bold text-gray-900 tablet:typo-subTitle1"
          >
            {description}
          </Typography>
          <Link href={buttonLink} className="w-fit">
            <Button
              variant="solid"
              size="md"
              className={isAuth ? 'w-[137px]' : 'w-[100px]'}
            >
              {buttonText}
            </Button>
          </Link>
        </Box>
        <Box className="h-[254px] overflow-y-hidden grid-in-image scrollbar-hide tablet:justify-self-end">
          <RollingGraphics />
        </Box>
      </GridLayout>
    </Box>
  );
};

export default SignUpBanner;
